<template>
  <v-container>
    <v-layout column>
      <v-flex class="display-2 text-xs-center my-5">About me</v-flex>
      <v-flex>
        <div class="headline mt-3">Career Changer</div>
        <p class="subheading mt-3">
          I recently completed a three month Makers Bootcamp where I taught
          myself Ruby, JavaScript and Swift by building a range of applications
          and websites. In my previous roles, I always pushed myself to learn
          more and to take ownership in as many areas as possible. I want to
          bring this attitude and my experience from Makers to my next role,
          building an outstanding product with clean, well-tested code, whilst
          continuing to develop my own engineering skills.
        </p>
      </v-flex>

      <v-flex>
        <div class="headline mt-3">Team Player</div>
        <p class="subheading mt-3">
          During my time at Hilton, I worked across disparate teams to meet the
          company’s legislative objectives, aggregating expertise and knowledge
          to tackle complex challenges. I want to bring this experience to my
          next role and be a bridge between teams, looking at the big picture to
          ensure the whole company succeeds.
        </p>
      </v-flex>
      <v-flex>
        <div class="headline mt-3">Project Driver</div>
        <p class="subheading mt-3">
          Whilst at the Makers Bootcamp, I developed an augmented reality (AR)
          iOS app with three team members over the course of 10 days. This work
          was undertaken as part of our final project, and while a number of
          teams wanted to continue working in Ruby or JavaScript, I was excited
          to learn something new instead. I quickly began generating ideas for
          the project and pitched my team with the concept of placing an AR
          signpost and allowing others to view it based on their geolocation.
        </p>
        <p>
          We started this project with no prior knowledge of Swift, XCode,
          Firebase, or any of the AR frameworks we eventually used. This meant
          that we had to work quickly to both learn and produce an app. To
          realise this, I led the team in learning the relevant aspects iOS
          development, sourcing good documentation and learning materials which
          were then distributed and absorbed. We built a strong first iteration
          of the app which is currently in beta on TestFlight.
        </p>
      </v-flex>
    </v-layout>
    <!-- <br /><br /> -->
  </v-container>
</template>

<script>
export default {
  name: 'MainDetail'
};
</script>

<style scoped></style>
